import { Translation } from "../../hooks/useTranslations";
import { CarTaskState } from "../carTasks/types";
import { UserLight } from "../users/types";

export type TaskState = {
  value: CarTaskState;
  label: string;
};

export const CarTaskToDo = "to-do";
export const CarTaskDone = "done";
export const CarTaskNotRequired = "not-required";

export const getTaskState = (i18n: Translation): TaskState[] => [
  { value: CarTaskDone, label: i18n.common.done },
  { value: CarTaskToDo, label: i18n.common.todo },
  { value: CarTaskNotRequired, label: i18n.common.notRequired },
];

export type CarTaskLog = {
  carTaskID: string;
  state?: CarTaskState;
  author?: UserLight;
  createdAt?: string;
};

export type UpsertCarTaskLog = {
  state: CarTaskState;
};
